'use strict';

angular.module('Directives').directive('ngToggle', function($timeout) {
    return {
        'restrict': 'A',
        'scope': {
            ngModel: '=',
            options: '=ngToggle'
        },
        'link': function linkingFunction($scope, element, attr) {
            $timeout(function(){
                element.toggles($scope.options);
                element.on('toggle', function(e, active) {
                    $scope.ngModel = active;
                });
            });
            $scope.$watch('ngModel', function(o, n) {
                element.toggles($scope.options);
                element.toggles($scope.ngModel);
            });
        },
        'controller': function($scope) {
            $scope.options = $scope.options || {};
            $scope.options.height = $scope.options.height || 26;
        }
    }
});


// WEBPACK FOOTER //
// ./js/directives/toggle.js